<template>
    <div class="animated fadeIn h-100 m-4">
      <CRow>
        <CCol sm="12"><h1>Buildings <!--CButton @click="exportDevice()" color="info" class="ml-2 float-right" size="sm" v-bind="{shape: 'pill'}">Export all</CButton--> <CButton @click="newBuilding()" color="info" class="m-0 float-right" size="sm" v-bind="{shape: 'pill'}">New building</CButton></h1></CCol>
      </CRow>
      <CRow>
        <CCol sm="9">
          <CCard v-for="item in buildings">
            <CCardHeader><b>{{item.name}}</b><div class="float-right"><CButton @click="showAddDeviceModal(item)" color="info" class="mr-1" size="sm" v-bind="{shape: 'pill'}">Add device</CButton> <CButton @click="editBuilding(item)" color="info" size="sm" v-bind="{shape: 'pill'}">Edit building</CButton></div></CCardHeader>
            <CCardBody>
              <CRow>
                <CCol md="6" lg="4" v-for="device in item.devices">
                  <CCard no-body>
                    <CCardBody style="height: 150px">
                      <CLink color="info" :href="'https://grafana.corryn.net/d/P6UJSSP7z/heimstaden?orgId=2&var-device_list=' + device.id"><h5><i v-if="device.armed !== null" class="fa fa-circle" aria-hidden="true" :style="'color: '+(device.armed ? '#2eb85c' : '#e55353')"></i> {{device.name}} {{device.config ? 'P' + device.config.floor : ''}}</h5></CLink>
                      <div style="top: 5px; right: 5px; position: absolute"><CButton color="link" v-on:click="showAddDeviceModal(item, device)" style="color: #39f;"><i class="fa fa-gear" aria-hidden="true"></i></CButton><CButton color="link" v-on:click="exportDevice(device.id)" style="color: #39f;"><i class="fa fa-download" aria-hidden="true"></i></CButton><CButton color="link" v-on:click="removeDevice(device)" style="color: rgb(229, 83, 83);"><i class="fa fa-times" aria-hidden="true"></i></CButton></div>
                      <div v-if="device.time != null"> 
                        Last update: {{(new Date(device.time*1000)).toLocaleString("sk-SK")}}<br/>
                        Last event: {{device.event}}<br />
                        <!--Water: {{item.water}} m<sup>3</sup><br/>
                        Electricity: {{item.power}} kWh<br/-->
                        <br/>
                        <span style="position: absolute; left: 20px; bottom: 10px"><CBadge :color="device.temperature < 18 ? 'danger' : 'secondary'">Low temperature</CBadge> <CBadge :color="device.humidity > 55 ? 'danger' : 'secondary'">High humidity</CBadge> <CBadge :color="device.tiltx < 70 || device.tiltx > 90 || device.tiltz < -20 || device.tiltz > 20 ? 'danger' : 'secondary'" data-toggle="tooltip" data-placement="top" :title="'['+(Math.round(device.tiltx*10)/10)+','+(Math.round(device.tilty*10)/10)+','+(Math.round(device.tiltz*10)/10)+']'">Position</CBadge></span>
                        <span style="position: absolute; right: 20px; bottom: 10px"><b>{{device.temperature}}°C</b> / <b>{{device.humidity}}%</b></span>
                      </div>
                    </CCardBody>
                  </CCard>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>          
        </CCol>
        <CCol sm="3">
          <CCard>
            <CCardHeader><b>Weather</b></CCardHeader>
            <CCardBody class="m-0 p-0">
              <div class="allmeteo-widget" data-ws="2201SH004" style="min-height: 320px"></div>
            </CCardBody>
          </CCard>
          <CCard>
            <CCardHeader><b>Weather</b></CCardHeader>
            <CCardBody class="m-0 p-0">
              <div class="allmeteo-widget" data-ws="2201SH016" style="min-height: 320px"></div>
            </CCardBody>
          </CCard>
          <CCard>
            <CCardHeader><b>Weather</b></CCardHeader>
            <CCardBody class="m-0 p-0">
              <div class="allmeteo-widget" data-ws="2201SH011" style="min-height: 320px"></div>
            </CCardBody>
          </CCard>          
        </CCol>
      </CRow>

      <CModal :title="(editDevice ? 'Edit' : 'Add') + ' device'" color="dark" :centered="true" :closeOnBackdrop="false" :show.sync="addDeviceModal">
        <CInput label="Device ID" placeholder="Enter device id" v-model="addDeviceId" :readonly="editDevice" />
        <CInput label="Device Name" placeholder="Enter device name" v-model="addDeviceName" />
        <CInput label="Floor" type="number" placeholder="Enter floor number where device is installed" v-model="addDeviceFloor" />

        <CButton color="info" v-on:click="armDevice" :disabled="editDeviceDownlink != ''">{{ editDeviceDownlink == '' ? 'Activate remotely' : 'Configuration will be sent within 24 hours.' }}</CButton>
        
        <template #footer>          
          <CButton @click="addDevice" color="success">Save</CButton>
          <CButton @click="addDeviceModal=false" color="secondary" >Cancel</CButton>
        </template>
      </CModal>
      
      <CModal :title="(currentBuilding && currentBuilding.id ? 'Edit' : 'New') + ' building'" color="dark" size="lg" :centered="true" :closeOnBackdrop="false" :show.sync="editBuildingModal">
        <CInput label="Name" placeholder="Enter name of building" v-model="currentBuilding.name" />
        <CSelect label="Group" :options="groupOptions" :value.sync="currentBuilding.parentgroup" />
        <CCard>
            <CCardHeader><b>Address</b> <CButton @click="tryGPS()" color="info" class="m-0 float-right" size="sm" v-bind="{shape: 'pill'}">Get address from GPS</CButton></CCardHeader>
            <CCardBody> 
              <CRow>
                <CCol><CInput label="Street" v-model="currentBuilding.street" /></CCol>
                <CCol><CInput label="City" v-model="currentBuilding.city" /></CCol>
              </CRow>
              <CRow>
                <CCol align="center"><CButton @click="gpsFromAddress()" color="info" class="mb-2" size="sm" v-bind="{shape: 'pill'}">Get coordinates from address</CButton></CCol>
              </CRow>
              <CRow>
                <CCol><CInput label="Latitude" v-model="currentBuilding.latitude" /></CCol>
                <CCol><CInput label="Longitude" v-model="currentBuilding.longitude" /></CCol>
              </CRow>
            </CCardBody>
        </CCard>
        <template #footer>
          <div style="width: 100%">
            <CButton v-if="currentBuilding.id" @click="removeBuilding(currentBuilding.id)" color="danger" class="float-left">Remove building</CButton>
            <CButton @click="editBuildingModal=false" color="secondary" class="float-right" >Cancel</CButton>
            <CButton @click="saveBuilding" color="success" class="float-right mr-2">Save</CButton>
            
          </div>
        </template>
      </CModal>
  </div>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'
import LineChart from './charts/LineChart.js'
import VueSlider from 'vue-slider-component'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import 'vue-slider-component/theme/antd.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import { telemetry } from '@/api'
import store from "@/store"

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD8vswyC9F9G4rpJnpfpgZAwL4J0C-FhO4',
    libraries: 'places'
  }
})

Vue.component('GmapCluster', GmapCluster)

export default {
  name: 'Building',
  components: {
      'gmap-custom-marker': GmapCustomMarker,
      VueSlider,
      LineChart,
      datePicker
  },
  data () {
    return {
      currentBuilding: {},
      addDeviceId: '',
      addDeviceName: '',
      addDeviceFloor: 0,
      editBuildingModal: false,
      addDeviceModal: false,
      appartments: [],
      center: {lat: 48, lng: 18},
      zoom: 9,
      //poles: [],
      fields: ['device', {key: 'devicename', label: 'Name'}, {key: 'time', label: 'Last event'}, 'event', 'tags', 'tiltx', 'tiltz'],
      events: [],
      eventFields: [{key: 'time', label: 'Time'}, 'appartment', 'event'],
      device: 'Device',
      deviceName: 'Device',
      temperaturecollection: {
        datasets: [{label: "Temperature", backgroundColor: '#39f', borderColor: '#39f', type: 'line', lineTension: 0, pointRadius: 0, fill:false, data: []}]
      },
      batterycollection: {
        datasets: [{label: "Battery", backgroundColor: '#39f', borderColor: '#39f', type: 'line', lineTension: 0, pointRadius: 0, fill:false, data: []}]
      },
      inclinationcollection: {
        datasets: [{label: "X axis", backgroundColor: '#39f', borderColor: '#39f', type: 'line', lineTension: 0, pointRadius: 0, fill:false, data: []},
                   {label: "Y axis", backgroundColor: '#40d640', borderColor: '#40d640', type: 'line', lineTension: 0, pointRadius: 0, fill:false, hidden:true, data: []},
                   {label: "Z axis", backgroundColor: '#ff3333', borderColor: '#ff3333', type: 'line', lineTension: 0, pointRadius: 0, fill:false, data: []}]
      },
      timeFormat: 'MM/DD/YYYY HH:mm:ss a',
      tempChartOptions: {
        scales: {
            xAxes: [{
                type: 'time',
                distribution: 'series',
                time: {
                  unit: 'hours',
                  //stepSize: 3, // I'm using 3 hour intervals here
                  tooltipFormat: 'DD.MM.YYYY - HH:mm:ss',
                  displayFormats: {
                    hours: 'DD.MM - HH:mm'
                  }
                }
            }]
        },
        plugins: {
          datalabels: {
            display: false
          }
        }
      },
      //markers: [],
      currentMarker: 0,
      paths: [],
      pathsLoaded: [],
      InfoWindowShown: false,
      clustering: false,
      hideLowAcc: true,
      gridSize: 50,
      view: "world",
      editDevice: false,
      editDeviceDownlink: '',
      dateFrom: this.startOfDay(this.previous2weeks(new Date())),
      dateTo: this.endOfDay(new Date()),
      options: {
        useCurrent: false,
        locale: 'sk'
      },
      sliderOptions: {
        min: 0,
        max: 1,
        interval: 1,
      },
      timestampFormater: v => (this.pathsLoaded.length>0?this.formatDate(this.pathsLoaded[this.pathsLoaded.length - v - 1].time):'')
    }
  },
  computed: {
    groupOptions: function () {
      var options = []
      for(var idx=0; idx < this.$store.state.groups.length; idx++) {
        options.push({ value: this.$store.state.groups[idx].id, label: this.$store.state.groups[idx].name })
      }
      return options
    },
    path() {
      return this.$router.history.current.fullPath
    },
    currentPole () {
      return this.$store.state.currentDevice
    },
    buildings () {
      return this.$store.state.buildings
    }
  },
  watch: {
    $route(to, from) {
      this.updateMap()
    },
    currentPole: function(prev, now) {
      this.redraw(true)
    },
    fixGPS() {
      console.log(this.fixGPS)
    }
  },
  mounted () {
    this.updateMap()
    this.appartments = this.fillApartments()
    this.loadBuildings()

    let allmeteoScript = document.createElement('script')
    allmeteoScript.setAttribute('src', 'https://weather.allmeteo.com/widget/allmeteo.widget.js')
    document.head.appendChild(allmeteoScript)
  },
  methods: {
    removeDevice(device) {
      var question = 'Are you sure you want to remove device ' + device.name + ' (' + device.id + ')'
      let ret = confirm(question)
      if(ret) {
        telemetry.updateDevice({id: device.id, building: null, config: {floor: 0} })
          .then(response => {
          this.$toasted.success('Device saved.')
          this.loadBuildings()
        }).catch((error) => {
          this.$toasted.error('Unable to save device.')
        })
      }
    },
    gpsFromAddress() {
      axios.get('https://maps.googleapis.com/maps/api/geocode/json?address='+encodeURIComponent(this.currentBuilding.street+', '+this.currentBuilding.city)+'&key=AIzaSyD8vswyC9F9G4rpJnpfpgZAwL4J0C-FhO4')
        .then(response => {
          if(response.data.status == 'OK' && response.data.results && response.data.results.length > 0) {
            this.currentBuilding.latitude = response.data.results[0].geometry.location.lat
            this.currentBuilding.longitude = response.data.results[0].geometry.location.lng            
          }
        })        
    },
    resolveName() {
      axios.get('https://maps.googleapis.com/maps/api/geocode/json?latlng='+this.currentBuilding.latitude+','+this.currentBuilding.longitude+'&result_type=street_address&key=AIzaSyD8vswyC9F9G4rpJnpfpgZAwL4J0C-FhO4')
        .then(response => {
          if(response.data.status == 'OK' && response.data.results && response.data.results.length > 0) {
            console.log(response.data.results)
            var address_components = response.data.results[0].address_components
            var street = ''
            var number = ''
            var city = ''
            for(let idx=0; idx < address_components.length; idx++) {
              if(address_components[idx].types.includes("route") && street == '') street = address_components[idx].long_name
              if(address_components[idx].types.includes("street_number") && number == '') number = ' ' + address_components[idx].long_name
              if(address_components[idx].types.includes("administrative_area_level_2") && city == '') city = address_components[idx].long_name
            }
            if(city == '') for(let idx=0; idx < address_components.length; idx++) if(address_components[idx].types.includes("sublocality") && city == '') city = address_components[idx].long_name
            this.currentBuilding.street = street + number
            if(this.currentBuilding.name == '') this.currentBuilding.name = this.currentBuilding.street
            this.currentBuilding.city = city
          }
        })
        .catch((error) => {
          this.$toasted.error('Unable to resolve location name')
        })
    },
    removeBuilding(building) {
      var question = 'Are you sure you want to remove this building?'
      let ret = confirm(question)
      if(ret) {
        telemetry.deleteBuilding(building)
          .then(response => {
          this.$toasted.success('Building deleted.')
          this.editBuildingModal = false
          this.loadBuildings()
        }).catch((error) => {
          this.$toasted.error('Unable to delete building.')
        })
      }
    },
    fixGPS(position) {
      this.currentBuilding.latitude = position.coords.latitude
      this.currentBuilding.longitude = position.coords.longitude
      this.resolveName()
    },
    errorGPS() {
      this.$toasted.error('Unable to retrieve location')
    },
    tryGPS() {
      if(window.navigator.geolocation) {
        window.navigator.geolocation.getCurrentPosition(this.fixGPS, this.errorGPS);
      } else {
        console.error("Geolocation is not supported by this browser.")
      }
    },
    armDevice() {
      this.editDeviceDownlink = '0000000040801003'
    },
    saveBuilding() {
      telemetry.updateBuilding(this.currentBuilding)
        .then(response => {
        this.$toasted.success('Building saved.')
        this.editBuildingModal = false
        this.loadBuildings()
      }).catch((error) => {
        this.$toasted.error('Unable to save building.')
      })
    },
    newBuilding(item) {
      this.currentBuilding = {
        name: '',
        street: '',
        city: '',
        latitude: null,
        longitude: null,
        parentgroup: this.groupOptions[0].value
      }
      this.editBuildingModal = true
    },
    editBuilding(item) {
      this.currentBuilding = Object.assign({}, item)
      this.editBuildingModal = true
    },
    exportDevice(device) {      
      telemetry.exportDevice(device).then(response => {
        this.$toasted.success('Export done.')

        if(!device) device = 'all'
        var csvContent = "data:text/csv;charset=utf-8,\ufeff" + response.data
        var encodedUri = encodeURI(csvContent)
        var link = document.createElement("a")
        link.setAttribute("href", encodedUri)
        link.setAttribute("download", "export-" + device + ".csv")
        link.innerHTML = "Click Here to download"
        link.dispatchEvent(
          new MouseEvent(`click`, {
            bubbles: true,
            cancelable: true,
            view: window
          })
        )
      }).catch((error) => {
        this.$toasted.error('Unable to export device data.')
      })
    },
    showAddDeviceModal(item, device) {
      this.addDeviceBuilding = device != null ? device.building : item.id
      this.addDeviceId = device != null ? device.id : ''
      this.addDeviceName = device != null ? device.name : ''
      this.addDeviceFloor = device != null ? device.config.floor : 0
      this.addDeviceModal = true
      this.editDevice = device != null
      this.editDeviceDownlink = ''
    },
    addDevice() {
      if(this.addDeviceName == '') this.addDeviceName = this.addDeviceId.toUpperCase()
      telemetry.updateDevice({id: this.addDeviceId.toUpperCase(), name: this.addDeviceName, building: this.addDeviceBuilding, downlink: this.editDeviceDownlink, config: {floor: this.addDeviceFloor} })
        .then(response => {
        this.$toasted.success('Device saved.')
        this.addDeviceModal = false
        this.loadBuildings()
      }).catch((error) => {
        this.$toasted.error('Unable to save device.')
      })
    },
    loadBuildings() {
      this.$store.dispatch("loadBuildings").then(() => {
      })

      /*
      telemetry.buildings().then(response => {
        if(response.data !== undefined) {
          console.log(response.data)
          this.buildings = response.data
        }
      }).catch((error) => {
        this.$toasted.error('Unable to access server.')
      })
      */
    },
    fillApartments() {
      //this.events = []
      var out = []
      for(var floor=0; floor<4; floor++) {
        for(var flat=1; flat<4; flat++) {
        var temp = 22 + Math.floor((Math.random()-0.5) * 6)
        var hum = 50 + Math.floor((Math.random()-0.5) * 20)
        var leak =
         out.unshift({
          name: 'Apartment '+(floor*3+flat),
          floor: 'Floor '+(floor+1),
          leak: Math.random() > 0.95 ? 'danger' : 'secondary',
          smoke: Math.random() > 0.95 ? 'danger' : 'secondary',
          temperature: temp,
          humidity: hum,
          water: (5 + Math.floor(Math.random() * 6)) * (new Date()).getMonth(),
          power: (110 + Math.floor(Math.random() * 100)) * (new Date()).getMonth(),
          })
          if(out[0].smoke == 'danger') out[0].temperature = out[0].temperature - 15
          if(out[0].leak == 'danger') out[0].humidity = out[0].humidity + 30
          if(out[0].leak == 'danger') this.events.push({time: (new Date()).getTime()/1000 - (Math.random()*14400), appartment: out[0].name, event: 'High humidity'})
          if(out[0].smoke == 'danger') this.events.push({time: (new Date()).getTime()/1000 - (Math.random()*14400), appartment: out[0].name, event: 'Low temperature'})
        }
      }
      return out
    },
    deviceLock () {
      var that = this
      telemetry.updateDevice({id: this.currentPole.device, config: {tiltx: this.currentPole.tiltx, tilty: this.currentPole.tilty, tiltz: this.currentPole.tiltz}})
        .then(response => {
        this.$toasted.success('Device Locked.')
        that.updateMap()
      }).catch((error) => {
        this.$toasted.error('Unable to save device.')
      })
    },
    previous2weeks (date) {
      date.setDate(date.getDate() - 14)
      return date
    },
    startOfDay (date) {
      date.setHours(0,0,0,0)
      return date
    },
    endOfDay (date) {
      date.setHours(23,59,59,999)
      return date
    },
    markerClass (event, temperature) {
      if(temperature < -5) {
        return "fa fa-snowflake-o"
      }
      switch(event) {
        case "open_full":
        case "open_one_tape":
        case "open_one_button":
        case "cap_released":
        case "disarmed":
        case "heartbeat_open":
              return "fa fa-envelope-open-o"
        case "sealed":
        case "sealed_recovered":
        case "armed":
        case "heartbeat_sealed":
              return "fa fa-envelope-o"
        case "stop": return "fa fa-hourglass-o"
        case "tracing": return "fa fa-truck"
        case "start": return "fa fa-arrows"
        case "heartbeat": return "fa fa-heartbeat"
      }
      return "fa fa-gear"
    },
    openDevice(dev, panto) {

    },
    formatDate(date) {
      return (new Date(date*1000)).toLocaleString()
    },
    updateMap() {
    }
  }
}
</script>
